<template>
  <div class="m-index">
    <img class="logo" src="./assets/mlogo.png" alt="">
    <img class="more" src="./assets/more.png" alt="" @click="asideHandle">
  </div>
  <el-drawer
    v-model="isAside"
    direction="ltr"
    :before-close="handleClose"
  >
    <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
      >
      <el-menu-item index="1" @click="home">
        <el-icon><icon-menu /></el-icon>
        <span>首页</span>
      </el-menu-item>
      <el-sub-menu index="2">
        <template #title>
          <el-icon></el-icon>
          <span @click="productInfo('all')">产品信息</span>
        </template>
        <el-menu-item-group>
          <el-sub-menu index="1-1">
            <template #title>
              <el-icon></el-icon>
              <span @click="productInfo('gr')">汽车太阳膜</span>
            </template>
            <el-menu-item v-for="item in categoryList" :index="item.id" @click="productInfo('gr', item.id)">{{item.title}}</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="1-2">
            <template #title>
              <el-icon></el-icon>
              <span @click="productInfo('bh')">漆面保护膜</span>
            </template>
            <el-menu-item v-for="item in categoryList" :index="item.id" @click="productInfo('bh', item.id)">{{item.title}}</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="1-3">
            <template #title>
              <el-icon></el-icon>
              <span @click="productInfo('gs')">车身改色膜</span>
            </template>
            <el-menu-item v-for="item in categoryList" :index="item.id" @click="productInfo('gs', item.id)">{{item.title}}</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="1-4">
            <template #title>
              <el-icon></el-icon>
              <span @click="productInfo('fh')">蓝卫仕防火膜</span>
            </template>
            <el-menu-item v-for="item in categoryList" :index="item.id" @click="productInfo('fh', item.id)">{{item.title}}</el-menu-item>
          </el-sub-menu>
        </el-menu-item-group>
      </el-sub-menu>
      <el-sub-menu index="3">
        <template #title>
          <el-icon></el-icon>
          <span>走进首纳</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="goAbout(0)">首纳简介</el-menu-item>
          <el-menu-item index="1-2" @click="goAbout(1)">荣誉介绍</el-menu-item>
          <el-menu-item index="1-3" @click="goAbout(2)">新闻资讯</el-menu-item>
          <el-menu-item index="1-4" @click="goAbout(3)">联系我们</el-menu-item>
        </el-menu-item-group>
      </el-sub-menu>
      <el-sub-menu index="4">
        <template #title>
          <el-icon></el-icon>
          <span>客户服务</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="goStore">门店查询</el-menu-item>
          <el-menu-item index="1-2" @click="goQuery">报价查询</el-menu-item>
          <el-menu-item index="1-3" @click="goSN">质保查询</el-menu-item>
        </el-menu-item-group>
      </el-sub-menu>
    </el-menu>
  </el-drawer>
</template>
<script setup>
import {ref} from 'vue'
import {useRouter} from 'vue-router'
import { product } from '@/data'
import { FetchProductCategory } from '@/api/api'

  const router = useRouter()
  const isAside = ref(false)
  const categoryList = ref([])
  const asideHandle = () => {
    isAside.value = !isAside.value
  }
  const home = () => {
    router.push({path: '/'})
  }
  const productInfo = (type, id) => {
    if (type == 'all') {
      router.push({path: '/product'})
    } else {
      getCategory(type);
      if (id) {
        router.push({path: '/product/' + type + id + '/detail'})
      } else {
        router.push({path: '/product/' + type + '/detail'})
      }
    }
  }
  const getCategory = (type) => {
    const id = product.find(e => e.value === type).id
    FetchProductCategory(id).then(res => {
      categoryList.value = res.data
    })
  }
  const goAbout = (type) => {
    router.push({path: '/sn/' + type})
  }
  const goStore = () => {
    window.location.href = 'https://m.jinlannami.com/mendianchaxun/'
  }
  const goQuery = () => {
    router.push({path: '/service/quote'})
  }
  const goSN = () => {
    router.push({path: '/warranty/index'})
  }
</script>
<style scoped lang="scss">
/* 响应式调整：屏幕较窄时，项目垂直排列 */
@media (max-width: 768px) {
  .m-index {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 34px;
    padding-right: 22px;
    height: 50px;
    background: #292A2A;

    .logo {
      width: 69.5px;
      display: block;
    }
  }
}
</style>
<style>
.el-drawer {
  width: 70% !important;
}
.el-menu{
  border-right: 0px !important;
}
.el-menu-item,.el-sub-menu{
  padding: 0px !important;
}
.el-sub-menu__title,.el-drawer__body{
  padding: 0px !important;
}
.el-sub-menu .el-menu-item{
  padding-left: 140px !important;
}
.el-menu-item.is-active{
  color: #303133 !important;
}
.el-sub-menu__title:hover,.el-menu-item:hover{
  background-color: #333 !important;
  color: #fff !important;
}
</style>